import { useSelector } from 'react-redux';
import { selectName, selectEmail, selectPhoneNumber } from '@store/order/selectors';



const CustomerInfo = (): JSX.Element => {

	const name = useSelector(selectName);
	const email = useSelector(selectEmail);
	const phoneNumber = useSelector(selectPhoneNumber);

	return (
		<div className='order-summary-element'>

			<h2>Údaje o Vás</h2>

			<div className='summary-grid'>
				
				<p>Jméno a Příjmení:</p>
				<p>{name ? name : '-'}</p>
				
				<p>E-mail:</p>
				<p>{email ? email : '-'}</p>

				<p>Telefon:</p>
				<p>{phoneNumber ? phoneNumber : '-'}</p>
			
			</div>

		</div>
	);
};

export default CustomerInfo;